import React, { createContext, useContext, useEffect, useState } from 'react';

const PageTitleContext = createContext({ pageTitle: '', setPageTitle: () => {}, pageStats: [], setPageStats: () => {} });

export const PageTitleProvider = ({ children }) => {
    const [pageTitle, setPageTitle] = useState('');
    const [pageStats, setPageStats] = useState([]);
    return (
        <PageTitleContext.Provider value={{ pageTitle, setPageTitle, pageStats, setPageStats }}>
            {children}
        </PageTitleContext.Provider>
    );
};

// Da chiamare nella pagina per mostrare il proprio titolo nella navbar invece che nel corpo pagina
export const usePageTitle = (title) => {
    const { setPageTitle } = useContext(PageTitleContext);
    useEffect(() => {
        setPageTitle(title || '');
        return () => setPageTitle('');
    }, [title, setPageTitle]);
};

// Contatori compatti mostrati in navbar a fianco del titolo, al posto delle StatsCards nel corpo
// pagina: usarlo quando lo spazio verticale per la tabella conta piu' dei dettagli extra delle card.
// stats: array di { label, value }
export const usePageStats = (stats) => {
    const { setPageStats } = useContext(PageTitleContext);
    // Dipendenza per valore (non per riferimento): stats e' spesso un array literal
    // ricreato a ogni render del chiamante, altrimenti l'effect scatterebbe ad ogni
    // render e, aggiornando uno state nel Provider (antenato), causerebbe un loop infinito.
    const statsKey = JSON.stringify(stats || []);
    useEffect(() => {
        setPageStats(stats || []);
        return () => setPageStats([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statsKey, setPageStats]);
};

// Da usare solo in DashboardLayout per leggere il titolo corrente e renderlo in navbar
export const useCurrentPageTitle = () => useContext(PageTitleContext).pageTitle;

// Da usare solo in DashboardLayout per leggere i contatori correnti e renderli in navbar
export const useCurrentPageStats = () => useContext(PageTitleContext).pageStats;
